export default defineNuxtPlugin(() => {
    const brandingStore = useBrandingStore();
    const authStore = useAuthStore();
    const {
        isDealerPortal
    } = usePortalTerminology();

    // Initialize branding when auth token is available
    const initializeBrandingWhenReady = () => {
        if (isDealerPortal.value) {
            brandingStore.initializeBranding();
        } else {
            brandingStore.clearBrandingState()
        }
    };

    // Watch for auth token changes
    watch(
        () => authStore.authToken,
        (newToken) => {
            if (newToken && isDealerPortal.value) {
                brandingStore.initializeBranding();
            } else {
                brandingStore.clearBrandingState()
            }
        },
        { immediate: true }
    );

    // Watch for organisation changes and refresh branding
    watch(
        () => authStore.refreshOrganisationKey,
        (newKey, oldKey) => {
            if (newKey !== oldKey && authStore.authToken) {
                initializeBrandingWhenReady();
            } else {
                brandingStore.clearBrandingState()
            }
        },
        { immediate: true }
    );
});
